export const getters = {
  categories: state => state.categories
}
